import { deepmerge } from '@mui/utils';
import type { PaletteOptions } from '@mui/material/styles';

import lightPalette from 'themes/paletteLight';
import darkPalette from 'themes/paletteDark';

type ThemeMode = 'light' | 'dark';

export default function createPalette(mode: ThemeMode): PaletteOptions {
  const basePalette = mode === 'light' ? lightPalette : darkPalette;
  return deepmerge(basePalette, {
    mode,
  });
}
